/* istanbul ignore file */
import styled, { css } from 'styled-components';

import { variables, Text } from 'app/shared/ui';

const { media } = variables;

export const InformationItemText = styled(Text)`
  ${media.sm(css`
    width: 86%;
  `)}

  ${media.md(css`
    width: 100%;
  `)}
`;
